import {EnumTradeInPayoutType, usePosStartConsumerCreateMutation} from "../../Queries";
import {ReturnsPagePath} from "./returns/ReturnsPage";
import {useNavigate} from "react-router-dom";
import {Button} from "@mui/material";
import {useRecoilState} from "recoil";
import {AccessContextData} from "../../providers/access/AppContextProvider";
import {ReturnsCartAtom} from "./returns/ReturnsCart";

export const PosStart = () => {
   const [userCreate] = usePosStartConsumerCreateMutation();
   const navigate = useNavigate();
   const [appContext, setAppContext] = useRecoilState(AccessContextData);
   const [, setReturnsCart] = useRecoilState(ReturnsCartAtom);

   const onStart = async () => {
      const consumer = await userCreate({
         variables: {
            shopId: appContext.shopId,
            locale: appContext.locale
         }
      });

      setReturnsCart({
         potentials: [],
         version: 0,
         payoutType: EnumTradeInPayoutType.Voucher,
         comments: []
      });

      setAppContext({
         shopId: window.shopId || window.brandId,
         disableLogin: window.disableLogin || false,
         pos: true,
         headless: window.headless || false,
         requestPotentialsSupported: false,
         tradeInComments: false,
         tradeInPayoutEnabled: false,
         tradeInPayoutPct: 0,
      });

      if (consumer.data?.ConsumerCreate?.accessToken) {
         navigate(ReturnsPagePath());
      }
   }

   return <div style={{textAlign: 'center', marginTop: '50px'}}>
      <Button variant={"contained"} onClick={onStart}>Start</Button>
   </div>
}